// Composants Nuria : sélecteur d'offres, barre d'achat fixe, carrousel, vidéos.

if (!customElements.get('nuria-offres')) {
  customElements.define(
    'nuria-offres',
    class NuriaOffres extends HTMLElement {
      connectedCallback() {
        this.quantite = this.querySelector('input[name="quantity"]');
        this.addEventListener('change', (event) => {
          if (event.target.type !== 'radio') return;
          this.quantite.value = event.target.value;
          this.querySelectorAll('.nuria-offre').forEach((offre) => {
            offre.classList.toggle('nuria-offre--active', offre.contains(event.target));
          });
        });
      }
    }
  );
}

if (!customElements.get('nuria-sticky')) {
  customElements.define(
    'nuria-sticky',
    class NuriaSticky extends HTMLElement {
      connectedCallback() {
        if (this.pret) return;
        this.pret = true;
        const section = this.closest('product-info') || document;
        this.cible = section.querySelector(this.dataset.cible) || section.querySelector('nuria-offres');
        const bouton = section.querySelector('.product-form__submit');
        // Un parent animé (transform) casserait le position: fixed : la barre va dans <body>.
        if (!(window.Shopify && window.Shopify.designMode)) document.body.appendChild(this);
        this.querySelector('button').addEventListener('click', () => {
          if (!this.cible) return;
          const haut = this.cible.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: haut, behavior: 'smooth' });
        });
        if (!bouton) return;
        this.bouton = bouton;
        window.addEventListener('scroll', () => this.maj(), { passive: true });
        this.maj();
      }

      // La barre apparaît une fois le bouton d'ajout passé au-dessus de l'écran.
      maj() {
        this.hidden = this.bouton.getBoundingClientRect().bottom > 0;
      }
    }
  );
}

if (!customElements.get('nuria-carrousel')) {
  customElements.define(
    'nuria-carrousel',
    class NuriaCarrousel extends HTMLElement {
      connectedCallback() {
        this.piste = this.querySelector('.nuria-carrousel__piste');
        this.slides = [...this.querySelectorAll('.nuria-carrousel__slide')];
        // Un conteneur de points vide se remplit d'un point par élément.
        const conteneur = this.querySelector('.nuria-carrousel__points');
        if (conteneur && !conteneur.children.length && this.slides.length > 1) {
          this.slides.forEach((_, i) => {
            const point = document.createElement('button');
            point.type = 'button';
            point.className = 'nuria-carrousel__point';
            point.setAttribute('aria-label', `Élément ${i + 1}`);
            conteneur.appendChild(point);
          });
        }
        this.points = [...this.querySelectorAll('.nuria-carrousel__point')];
        this.querySelector('.nuria-carrousel__fleche--prec')?.addEventListener('click', () => this.aller(-1));
        this.querySelector('.nuria-carrousel__fleche--suiv')?.addEventListener('click', () => this.aller(1));
        this.points.forEach((point, i) => point.addEventListener('click', () => this.montrer(i)));
        this.piste.addEventListener('scroll', () => this.majPoints(), { passive: true });
        this.majPoints();
      }

      indexCourant() {
        const gauche = this.piste.scrollLeft;
        let meilleur = 0;
        this.slides.forEach((slide, i) => {
          if (Math.abs(slide.offsetLeft - this.piste.offsetLeft - gauche) < Math.abs(this.slides[meilleur].offsetLeft - this.piste.offsetLeft - gauche)) meilleur = i;
        });
        return meilleur;
      }

      montrer(i) {
        const slide = this.slides[Math.max(0, Math.min(i, this.slides.length - 1))];
        this.piste.scrollTo({ left: slide.offsetLeft - this.piste.offsetLeft, behavior: 'smooth' });
      }

      aller(pas) {
        this.montrer(this.indexCourant() + pas);
      }

      majPoints() {
        const i = this.indexCourant();
        this.points.forEach((point, j) => point.setAttribute('aria-current', j === i ? 'true' : 'false'));
      }
    }
  );
}

if (!customElements.get('nuria-onglets')) {
  customElements.define(
    'nuria-onglets',
    class NuriaOnglets extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const bouton = event.target.closest('[role="tab"]');
          if (!bouton) return;
          this.querySelectorAll('[role="tab"]').forEach((b) => b.setAttribute('aria-selected', b === bouton ? 'true' : 'false'));
          this.querySelectorAll('[role="tabpanel"]').forEach((p) => {
            p.hidden = p.id !== bouton.getAttribute('aria-controls');
          });
        });
      }
    }
  );
}

if (!customElements.get('nuria-avant-apres')) {
  customElements.define(
    'nuria-avant-apres',
    class NuriaAvantApres extends HTMLElement {
      connectedCallback() {
        const curseur = this.querySelector('input[type="range"]');
        curseur?.addEventListener('input', () => this.style.setProperty('--nuria-position', `${curseur.value}%`));
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const video = event.target.closest('.nuria-videos video');
  if (!video) return;
  video.muted = !video.muted;
  video.closest('.nuria-videos__carte')?.classList.toggle('nuria-videos__carte--son', !video.muted);
  if (video.paused) video.play();
});

// Tiroir panier (24/10/2026) ---------------------------------------------------------------------------------------

// Minuteur « Vos articles sont réservés pendant mm:ss ». L'échéance vit dans sessionStorage : le tiroir est
// re-rendu à chaque changement de quantité et le compte ne doit pas repartir à 10:00. À zéro, il repart pour un tour.
if (!customElements.get('nuria-minuteur')) {
  customElements.define(
    'nuria-minuteur',
    class NuriaMinuteur extends HTMLElement {
      connectedCallback() {
        this.temps = this.querySelector('.nuria-panier__minuteur-temps');
        this.duree = (parseInt(this.dataset.minutes, 10) || 10) * 60000;
        this.tic();
        this.intervalle = setInterval(() => this.tic(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.intervalle);
      }

      tic() {
        let fin = parseInt(sessionStorage.getItem('nuriaPanierFin'), 10);
        if (!fin || fin <= Date.now()) {
          fin = Date.now() + this.duree;
          sessionStorage.setItem('nuriaPanierFin', String(fin));
        }
        const reste = Math.max(0, Math.round((fin - Date.now()) / 1000));
        const mm = String(Math.floor(reste / 60)).padStart(2, '0');
        const ss = String(reste % 60).padStart(2, '0');
        if (this.temps) this.temps.textContent = `${mm}:${ss}`;
      }
    }
  );
}

// « Soyez notifié(e) » : l'interrupteur note le choix dans les attributs du panier (visible sur la commande).
if (!customElements.get('nuria-notif')) {
  customElements.define(
    'nuria-notif',
    class NuriaNotif extends HTMLElement {
      connectedCallback() {
        const caseACocher = this.querySelector('input[type="checkbox"]');
        // Le « change » ne doit pas remonter à cart-drawer-items : Dawn le prendrait pour un champ de quantité,
        // lui poserait une erreur de validation et bloquerait le bouton « Continuer » (constaté au test du 24/10).
        caseACocher?.addEventListener('change', (event) => {
          event.stopPropagation();
          caseACocher.setCustomValidity('');
          fetch(`${window.routes.cart_update_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { Notifications: caseACocher.checked ? 'oui' : '' } }),
          }).catch(() => {});
        });
      }
    }
  );
}

// Offres complémentaires du tiroir : ajout en un clic, puis le tiroir est re-rendu par Dawn (renderContents).
document.addEventListener('click', (event) => {
  const bouton = event.target.closest('.nuria-upsell__ajouter');
  if (!bouton) return;
  event.preventDefault();
  const tiroir = document.querySelector('cart-drawer');
  bouton.setAttribute('aria-busy', 'true');
  const sections = tiroir ? tiroir.getSectionsToRender().map((section) => section.id) : [];
  fetch(`${window.routes.cart_add_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: Number(bouton.dataset.variantId), quantity: 1 }],
      sections,
      sections_url: window.location.pathname,
    }),
  })
    .then((reponse) => reponse.json())
    .then((etat) => {
      if (etat.status) throw new Error(etat.description || etat.message);
      if (tiroir && etat.sections) {
        tiroir.renderContents({ ...etat, id: etat.items?.[0]?.product_id });
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nuria-upsell', cartData: etat });
      }
    })
    .catch((erreur) => {
      console.error(erreur);
      bouton.removeAttribute('aria-busy');
    });
});
